/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { SendReservePaymentMutationVariables } from '../gql/graphql';
import { GET_RESERVES } from './reserves.query';

export function useSendReservePaymentMutation(
  options: MutationHookOptions<any, SendReservePaymentMutationVariables> = {}
) {
  const [sendReservePayment, { loading, error, reset, data }] = useMutation(
    graphql(`
      mutation sendReservePayment(
        $reserveUuid: String!
        $reservePaymentInput: ReservePaymentInput!
      ) {
        sendReservePayment(
          reserveUuid: $reserveUuid
          details: $reservePaymentInput
        ) {
          uuid
          tenant
          remainingReserve
          paymentTotal
          totalIncurred
        }
      }
    `),
    {
      refetchQueries: [GET_RESERVES],
      awaitRefetchQueries: true,
      ...options,
    }
  );

  return {
    sendReservePayment,
    loading,
    error,
    reset,
    data,
  };
}
